import { Form, Input, Button } from "antd"
import { MailOutlined, LockOutlined } from "@ant-design/icons"
import { apiUser } from "../../api"
import { useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import { setConfig } from "../../lib/localstorage"
import { useStore } from "../../components/ui"

// Dark - Schemas / jnt-primary-color (theo SVG + CSS)
const PAGE_BG = "#3949AB"
const PANEL_LEFT_BG = "#3949AB"
const PANEL_RIGHT_BG = "#ffffff"
const BORDER_COLOR = "#E6E9FA"
const PRIMARY_COLOR = "#3949AB"
const PRIMARY_DARK = "#00227B"
const TITLE_COLOR = "#1a1a1a"
const PLACEHOLDER_COLOR = "#828282"
const INPUT_BORDER = "#D0D0D0"
const CARD_RADIUS = 24
const CARD_SHADOW = "0 24px 64px rgba(0,0,0,0.2)"

const Login = () => {
  const { setAuth } = useStore()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [narrow, setNarrow] = useState(typeof window !== "undefined" && window.innerWidth < 768)
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < 768)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const res = await apiUser.login(values)
      const data = res?.data ?? res
      const menu = Array.isArray(data?.menu) ? data.menu : []
      setAuth({
        token: data?.token,
        refresh: data?.refresh,
        user: data?.user,
        menus: menu,
        logo: data?.logo_side_bar,
        permissions: data?.permissions
      })
      if (data?.base_link) setConfig("base_link", data.base_link)
      setTimeout(() => navigate("/staff/list"), 0)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: PAGE_BG,
        padding: 24,
        boxSizing: "border-box",
        overflow: "hidden"
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          width: "100%",
          maxWidth: 1218,
          minHeight: 743,
          display: "flex",
          borderRadius: CARD_RADIUS,
          overflow: "hidden",
          border: `1px solid ${BORDER_COLOR}`,
          boxShadow: CARD_SHADOW,
          position: "relative",
          zIndex: 1
        }}
      >
        {/* Left: deep blue panel */}
        {!narrow && (
          <div
            style={{
              width: 732,
              minWidth: 732,
              flex: "0 0 55%",
              maxWidth: "55%",
              background: PANEL_LEFT_BG,
              padding: "48px 40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <div style={{ width: "100%", textAlign: "left" }}>
              <div style={{ color: "rgba(255,255,255,0.9)", fontSize: 14, fontWeight: 600, letterSpacing: "0.02em", marginBottom: 4 }}>
                BỆNH VIỆN
              </div>
              <div style={{ color: "#fff", fontSize: 18, fontWeight: 700, letterSpacing: "0.02em" }}>
                ĐẠI HỌC Y HÀ NỘI
              </div>
            </div>

            {/* Vòng tròn phía sau (Ellipse 4): 221x221, #00227B, opacity 0.6 + ảnh phi hành gia */}
            <div
              style={{
                position: "relative",
                flex: "none",
                order: 0,
                flexGrow: 0,
                width: 221,
                height: 221,
                maxWidth: "90%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}
            >
              <svg
                width={221}
                height={221}
                viewBox="0 0 221 221"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  width: "100%",
                  height: "100%"
                }}
              >
                <circle opacity="0.6" cx="110.5" cy="110.5" r="110.5" fill="#00227B" />
              </svg>
              <img
                src="/images/astronaut-login.png"
                alt=""
                style={{
                  position: "relative",
                  zIndex: 1,
                  width: 193.45,
                  height: 219,
                  maxWidth: "88%",
                  maxHeight: "99%",
                  objectFit: "contain"
                }}
              />
            </div>

            <div style={{ textAlign: "center", maxWidth: 320, marginTop: -20 }}>
              <div style={{ color: "#fff", fontSize: 22, fontWeight: 700, lineHeight: 1.4, marginBottom: 8 }}>
                Chào mừng bạn
              </div>
              <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 14 }}>
                Chỉ vài bước để bắt đầu
              </div>
            </div>

          </div>
        )}

        {/* Right: white form panel */}
        <div
          style={{
            flex: narrow ? "1 1 100%" : "0 0 45%",
            minWidth: narrow ? undefined : 486,
            background: PANEL_RIGHT_BG,
            borderRadius: narrow ? CARD_RADIUS : `0 ${CARD_RADIUS}px ${CARD_RADIUS}px 0`,
            padding: "40px 56px 32px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 24
          }}
        >
          <h2
            style={{
              fontSize: 24,
              fontWeight: 600,
              color: TITLE_COLOR,
              margin: 0,
              paddingBottom: 8,
              textAlign: "center"
            }}
          >
            Đăng nhập
          </h2>

          <Form name="login" onFinish={onFinish} layout="vertical" requiredMark={false} style={{ width: "100%", maxWidth: 358, margin: "0 auto" }}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: "Vui lòng nhập tài khoản hoặc email" }]}
              style={{ marginBottom: 16 }}
            >
              <Input
                size="large"
                placeholder="Email"
                prefix={<MailOutlined style={{ color: PLACEHOLDER_COLOR, marginRight: 8 }} />}
                style={{
                  height: 44,
                  borderRadius: 10,
                  borderColor: INPUT_BORDER
                }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
              style={{ marginBottom: 8 }}
            >
              <Input.Password
                size="large"
                placeholder="Mật khẩu"
                prefix={<LockOutlined style={{ color: PLACEHOLDER_COLOR, marginRight: 8 }} />}
                style={{
                  height: 44,
                  borderRadius: 10,
                  borderColor: INPUT_BORDER
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 24 }}>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
                block
                style={{
                  height: 44,
                  borderRadius: 10,
                  backgroundColor: PRIMARY_COLOR,
                  borderColor: PRIMARY_COLOR,
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#fff"
                }}
              >
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default Login
